import script from "./TradeTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./TradeTitle.vue?vue&type=script&setup=true&lang=ts"

import "./TradeTitle.vue?vue&type=style&index=0&id=8f21d388&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f21d388"]])

export default __exports__